export default __webpack_public_path__ + "static/TT_Commons_Pro_Trial_Normal-ffa5135edab2a5183ff4349624631b74.woff";